import { createFileRoute, redirect } from "@tanstack/react-router";

// 项目工作流已并入工作台「项目」展开层；本路由保留为深链兼容
export const Route = createFileRoute("/_app/projects/")({
  beforeLoad: () => {
    throw redirect({
      to: "/workbench",
      search: { view: "project" },
      replace: true,
    });
  },
});
